import { fromJS, List, Map } from 'immutable'
import _ from 'lodash'

export function processUpdateFooterSettings(settings) {
  let result = settings

  if (!result.getIn(['elements', 'Footer'])) {
    result = result.setIn(
      ['elements', 'Footer'],
      fromJS({
        type: 'Strip',
        props: {
          styleRef: 'Footer',
        },
        children: _.reduce(
          result.getIn(['elements'], Map()).toJS(),
          (r, v, k) => {
            if (v.parent === 'Footer') {
              return [...r, k]
            } else {
              return r
            }
          },
          []
        ),
      })
    )
  }

  if (typeof result.getIn(['styles', 'Footer', 'lg', 'columns']) === 'undefined') {
    result = result.setIn(['styles', 'Footer', 'lg', 'columns'], 1)
  }
  if (typeof result.getIn(['styles', 'Footer', 'lg', 'rows']) === 'undefined') {
    result = result.setIn(['styles', 'Footer', 'lg', 'rows'], 1)
  }
  if (typeof result.getIn(['styles', 'Footer', 'lg', 'areas']) === 'undefined') {
    result = result.setIn(['styles', 'Footer', 'lg', 'areas'], fromJS([['a']]))
  }

  result = result.setIn(
    ['elements'],
    result.getIn(['elements'], Map()).map((el) => {
      if (el.get('parent') === 'Footer' && !el.getIn(['props', 'lg', 'gridArea'])) {
        return el.setIn(['props', 'lg', 'gridArea'], 'a')
      } else {
        return el
      }
    })
  )

  if (!result.getIn(['theme', 'lg', 'Footer', 'root', 'height'])) {
    result = result.setIn(['theme', 'lg', 'Footer', 'root', 'height'], '100')
  }

  return result
}

export function safeUpdateFooterElement(project) {
  let footerEl = _.get(project, 'Settings.elements.Footer')
  if (!footerEl) {
    footerEl = {
      type: 'Strip',
      props: {
        styleRef: 'Footer',
      },
      children: _.reduce(
        _.get(project, 'Settings.elements', {}),
        (r, v, k) => {
          if (v.parent === 'Footer') {
            return [...r, k]
          } else {
            return r
          }
        },
        []
      ),
    }
    _.set(project, 'Settings.elements.Footer', footerEl)
    _.set(project, 'Settings.styles.Footer.lg', {
      type: 'Footer',
      columns: 1,
      rows: 1,
      areas: [['a']],
    })
    _.each(_.get(project, 'Settings.elements', {}), (v, k) => {
      if (v.parent === 'Footer') {
        _.set(v, 'props.lg.gridArea', 'a')
      }
    })
  } else {
    if (typeof _.get(project, 'Settings.styles.Footer.lg.columns') === 'undefined') {
      _.set(project, 'Settings.styles.Footer.lg.columns', 1)
    }
    if (typeof _.get(project, 'Settings.styles.Footer.lg.rows') === 'undefined') {
      _.set(project, 'Settings.styles.Footer.lg.rows', 1)
    }
    if (!_.isArray(_.get(project, 'Settings.styles.Footer.lg.areas'))) {
      _.set(project, 'Settings.styles.Footer.lg.areas', [['a']])
    }
    _.each(_.get(project, 'Settings.elements', {}), (v, k) => {
      if (v.parent === 'Footer' && !_.get(v, 'props.lg.gridArea')) {
        _.set(v, 'props.lg.gridArea', 'a')
      }
    })
  }
}
